import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import * as Highcharts from "highcharts";
import { ChartViewDTO } from "src/app/new-dashboard/core/model/chart_view/chart-view-dto";
import { NewDashboardCorporateService } from "src/app/new-dashboard/core/service/new-dashboard-corporate.service";
import { DashboardAllMarcheService } from "src/app/new-dashboard/core/service/dashboard-all-marche.service";
import { DurationByProduitDTO } from "src/app/new-dashboard/core/model/duration-by-produit-dto";
import { DurationByTaskDTO } from "src/app/new-dashboard/core/model/duration-by-task-dto";
import { SlaProduitDTO } from "src/app/new-dashboard/core/model/sla-produit-dto";

@Component({
  selector: "app-corp-qos-produit",
  templateUrl: "./corp-qos-produit.component.html",
  styleUrls: ["./corp-qos-produit.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class CorpQosProduitComponent implements OnInit {
  highcharts = Highcharts;
  chartOptionsProduitByPeriode: any;
  chartOptionsSlaPeriodeParProfile: any;
  //chartOptionsSlaTacheParProduit: any;

  produitByPeriode: ChartViewDTO;
  slaPeriodeParProfile: ChartViewDTO;
  slaTacheParProduit: ChartViewDTO;

  durationByProduitDTOs: DurationByProduitDTO[];
  displayedProduitColumnsList: string[] = [
    "codeProduit",
    "qtyRequest",
    "duration",
    "actions",
  ];
  durationByTaskDTOs: DurationByTaskDTO[];
  durationByTaskDTOArray: Array<DurationByTaskDTO[]> = [];

  slaProduitDTOs: SlaProduitDTO[];

  constructor(
    private _newDashboardCorporateService: NewDashboardCorporateService,
    private _dashboardAllMarcheService: DashboardAllMarcheService
  ) {}

  ngOnInit() {
    this.slaProduitParPeriode();
    this.getSlaPeriodeParProfile("_");
    //this.getSlaTacheParProduit("_");
    this.durationProduit("_");
    //this.getSlaProduit("_");
  }

  slaProduitParPeriode() {
    this._newDashboardCorporateService
      .slaProduitParPeriode()
      .pipe(first())
      .subscribe(
        (response) => {
          this.produitByPeriode = response;

          this.chartOptionsProduitByPeriode = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement moyen des produits sur les 6 derniers mois",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.produitByPeriode.categories,
            },
            yAxis: {
              title: {
                text: "Jour(s)",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.produitByPeriode.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getSlaPeriodeParProfile(agency) {
    this._dashboardAllMarcheService
      .slaPeriodeParProfile("CORPORATE", agency)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaPeriodeParProfile = response;

          this.chartOptionsSlaPeriodeParProfile = {
            chart: {
              type: "spline",
            },
            title: {
              text: "Temps de traitement par profil sur les 6 derniers mois ",
            },
            subtitle: {
              text: null,
            },
            xAxis: {
              categories: this.slaPeriodeParProfile.categories,
            },
            yAxis: {
              title: {
                text: "Jours",
              },
            },
            tooltip: {
              valueSuffix: null,
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },

            series: this.slaPeriodeParProfile.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /*getSlaTacheParProduit(codeAgence) {
    this._dashboardAllMarcheService
      .slaTacheParProduit("CORPORATE", codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaTacheParProduit = response;

          this.chartOptionsSlaTacheParProduit = {
            chart: {
              type: "bar",
            },
            title: {
              text: "SLA tâches par produit",
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true,
            },
            xAxis: {
              categories: this.slaTacheParProduit.categories,
              title: {
                text: null,
              },
            },
            yAxis: {
              min: 0,
              title: {
                text: "Jours",
                align: "high",
              },
              labels: {
                overflow: "justify",
              },
            },
            tooltip: {
              valueSuffix: "",
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true,
                },
                showInLegend: true,
              },
              series: {
                stacking: "normal",
              },
            },
            credits: {
              enabled: false,
            },
            series: this.slaTacheParProduit.series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }*/

  durationProduit(codeAgence) {
    this._dashboardAllMarcheService
      .durationProduit("CORPORATE", codeAgence)
      .subscribe(
        (data) => {
          this.durationByProduitDTOs = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  durationTask(codeProduit) {
    this._dashboardAllMarcheService
      .durationTaskByProduit(codeProduit)
      .subscribe(
        (data) => {
          this.durationByTaskDTOs = data;
          this.durationByTaskDTOArray[codeProduit] = this.durationByTaskDTOs;
        },
        (error) => {
          console.log(error);
        }
      );
  }

 /* getSlaProduit(codeAgence) {
    this._dashboardAllMarcheService
      .slaProduit("CORPORATE", codeAgence)
      .pipe(first())
      .subscribe(
        (response) => {
          this.slaProduitDTOs = response;
        },
        (error) => {
          console.log(error);
        }
      );
  }*/
}
